import {DormerMaterialViewModel} from "@hec/api-dtos";
import {DormerRootState} from "../DormerRootState";

export const getDormerMaterialsSelector = (state: DormerRootState): DormerMaterialViewModel[] => {
  return state.dormerMaterials.dormerMaterials;
}
export const getSelectedDormerMaterialSelector = (state: DormerRootState): DormerMaterialViewModel | null => {
  return state.dormerMaterials.selectedDormerMaterialViewModel
}
